var html = document.documentElement;
var body = document.querySelector('body');

var classList = [];

is.desktop() ? classList.push('is-desktop') : null;
is.tablet() ? classList.push('is-tablet') : null;
is.mobile() ? classList.push('is-mobile') : null;
is.ie() ? classList.push('is-ie') : null;
is.safari() ? classList.push('is-safari') : null;

classList.forEach (className => {
  html.classList.add(className);
});

window.addEventListener('DOMContentLoaded', () => {
  body.classList.add('is-ready');
});

window.addEventListener('load', () => {
  body.classList.add('is-loaded');
});